import { Typography, TypographyVariant } from '@material-ui/core';
import { ColorDynamic, Column, Columns } from '@superdispatch/ui';
import styled from 'styled-components';

export const DottedLine = styled.div`
  border-bottom: 1px dashed ${ColorDynamic.Silver400};
  margin: 0px 8px;
  height: 7px;
`;

interface DottedLineRowParams {
  title: string;
  value: string | number | JSX.Element;
  boldValue?: boolean;
  variant?: TypographyVariant;
}

export function DottedLineRow({
  title,
  value,
  boldValue,
  variant,
}: DottedLineRowParams) {
  return (
    <Columns align="center">
      <Column width="content">
        <Typography
          variant={variant || (boldValue ? 'h5' : 'caption')}
          color={boldValue || variant ? undefined : 'textSecondary'}
          gutterBottom={true}
        >
          {title}
        </Typography>
      </Column>
      <Column width="fluid">
        <DottedLine />
      </Column>
      <Column width="content">
        <Typography
          align="right"
          color="textPrimary"
          variant={variant || (boldValue ? 'h5' : 'caption')}
        >
          {value}
        </Typography>
      </Column>
    </Columns>
  );
}
